import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { SalesOrders } from "./-components/SalesOrders";
import { SearchSchema } from "./-zod-schema";

export const Route = createFileRoute(
  "/_staff/marketplace/_store/store/sales-orders/",
)({
  validateSearch: zodValidator(SearchSchema),
  component: SalesOrders,
});
